import Table from "@/common/components/Table";
import { DGHealthWrapper } from "../style";
import { Pagination } from "@/common/components/pagination";
import { DELIVERY_REQUEST_URLS } from "@/common/constants";
import useQuery from "@/hooks/useQuery";
import { useCallback, useMemo, useState } from "react";
import {
  dgFinancialTableHeaders,
  dgFinancialTableKey,
  getDGFinanceData,
  getRequestDetails,
} from "../data";
import { KeyValueObj } from "@/common/types";
import { Modal } from "@/common/components/modal";
import ViewFundRequest from "./viewFundRequest";

const DGHealthDashboard = () => {
  const [currentRow, setCurrentRow] = useState<KeyValueObj>({});
  const [financialsPerPage, setFinancialsPerPage] = useState(10);
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentSales, setCurrentSales] = useState<KeyValueObj>({});
  const [showViewModal, setShowViewModal] = useState<boolean>(false);

  const {
    data: salesData,
    meta: salesMeta,
    loading: salesLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${financialsPerPage}&page=${financialsPerPage}`
  );

  const handleSalesView = () => {
    setCurrentSales(currentRow);
    setShowViewModal(true);
  };

  const handleDropdownClick = useCallback(
    (row: KeyValueObj) => {
      const willShow = !showDropdown;
      const newRow = willShow ? row : {};

      setCurrentRow(newRow);
      setShowDropdown(willShow);
    },
    [showDropdown]
  );
  const salesDropdowns = useMemo(
    () =>
      currentRow?.trackingID?.value !== "--"
        ? [{ label: "View", action: handleSalesView }]
        : [{ label: "View", action: handleSalesView }],
    [handleSalesView, currentRow]
  );
  return (
    <DGHealthWrapper>
      <div className="table-wrapper">
        <Table
          tableHeaders={dgFinancialTableHeaders}
          tableKeys={dgFinancialTableKey}
          tableData={getDGFinanceData(salesData)}
          tableTitle="Fund Allocation Request"
          tableSubtitle={(salesMeta?.total_count ?? "0") + " Requests"}
          loading={salesLoading}
          handleDropDownClicked={handleDropdownClick}
          showDropDown={showDropdown}
          dropDownOptions={salesDropdowns}
          spaced
          rowLineColor="light"
        />
        <Pagination
          pageCount={salesMeta?.total_pages}
          onNextPage={(event: any) => setFinancialsPerPage(event.selected)}
          onPerPageChange={(event: any) =>
            setFinancialsPerPage(event?.target?.value)
          }
        />
      </div>
      <Modal
        title="Fund Request Details"
        isOpen={showViewModal}
        close={() => setShowViewModal(false)}
      >
        <ViewFundRequest data={getRequestDetails(currentSales) as any} />
      </Modal>
    </DGHealthWrapper>
  );
};

export default DGHealthDashboard;
